import L from 'leaflet';

export default class ConvertGeoJsonToPolylineData {
    public static runConvertor(obj: any) {
        let _mercBoundary: any[] = [];
        const processGeoJSONObject = (obj: any) => {
            if (obj.type === 'GeometryCollection') {
                obj.geometries.forEach(processGeoJSONObject);
            } else if (obj.type === 'Feature') {
                processGeoJSONObject(obj.geometry);
            } else if (obj.type === 'FeatureCollection') {
                obj.features.forEach(processGeoJSONObject);
            } else if (obj.type === 'Polygon') {
                _mercBoundary = _mercBoundary.concat(
                    this._toPolygonGeometry([obj.coordinates])
                );
            } else if (obj.type === 'MultiPolygon') {
                _mercBoundary = _mercBoundary.concat(
                    this._toPolygonGeometry(obj.coordinates)
                );
            }
        };

        processGeoJSONObject(obj);
        return _mercBoundary;
    }

    static _toPolygonGeometry(b: any): any[] {
        var res: any[] = [];
        var c, r, p, mercComponent, mercRing, coords;

        for (c = 0; c < b.length; c++) {
            mercComponent = [];
            for (r = 0; r < b[c].length; r++) {
                mercRing = [];
                for (p = 0; p < b[c][r].length; p++) {
                    coords = L.latLng(b[c][r][p][1], b[c][r][p][0]);
                    mercRing.push(coords);
                }
                mercComponent.push(mercRing);
            }
            res.push(mercComponent);
        }

        return res;
    }
}
